import React, { useEffect, useState } from 'react';
import plusIcon from '../../svgs/footer-mobile-expand.svg';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { Mousewheel } from 'swiper/modules';
import { FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/mousewheel';
import 'swiper/css/free-mode';
import Spinner from '../react-elements/Spinner';

const Favourites = ({ menuItems, activeFilters: stringFilters }) => {
    const [favouriteItems, setFavouriteItems] = useState(menuItems);
    const [activeIndex, setActiveIndex] = useState<number | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    const activeFilters = stringFilters.map(filter => parseInt(filter.toString(), 10));

    const visibleFavouriteItems = favouriteItems.filter(item => {
        const itemTags = item.tags.map(tag => tag.id);
        return activeFilters.length === 0 || activeFilters.every(filter => itemTags.includes(filter));
    });

    useEffect(() => {
        setIsLoading(false);
    }, [menuItems]);

    if (!isLoading && (!favouriteItems || favouriteItems.length === 0 || visibleFavouriteItems.length === 0)) {
        return null;
    }

    const handleItemClick = (index: number) => {
        if (window.innerWidth < 1200) {
            setActiveIndex(activeIndex === index ? null : index);
        }
    };

    const renderMockCard = (index: number) => (
        <SwiperSlide 
            key={`mock-${index}`}
            className="c__favourites-item | !w-[255px] xl:!w-[343px] bg-[#e5dacf] rounded-[20px] xl:mr-5 overflow-hidden group"
        >
            <div className="c__favourites-item-image | w-full h-[180px] xl:h-[240px] bg-gray-300">
                <Spinner />
            </div>
            <div className="c__favourites-item-card | max-h-[55px]">
                <div className="c__favourites-item-card-inner | bg-black p-3 h-[55px]">
                    <div className="h-6 bg-gray-400 rounded w-3/4 animate-pulse"></div>
                </div>
            </div>
        </SwiperSlide>
    );

    return (
        <div className="c__favourites | max-w-full pb-8 xl:pb-12 relative">
            {/* <div className="c__favourites-slider-overlay | w-[10%] z-10 h-full absolute top-0 right-0"></div> */}
            <Swiper 
                className="c__favourites-slider"
                slidesPerView='auto'
                spaceBetween={20}
                modules={[Pagination, Mousewheel, FreeMode]}
                pagination={{
                    enabled: true,
                    clickable: true
                }}
                breakpoints={{
                    1200: {
                        slidesPerView: 'auto',
                        spaceBetween: 0,
                        pagination: {
                            enabled: false
                        },
                        freeMode: {
                            enabled: true,
                            momentumBounce: false,
                        },
                        mousewheel: {
                            enabled: true,
                            forceToAxis: true,
                        }
                    }
                }}
            >
                {isLoading
                    ? Array.from({ length: 3 }).map((_, index) => renderMockCard(index))
                    : visibleFavouriteItems.map((item, index) => (
                        <SwiperSlide 
                            key={index} 
                            className="c__favourites-item | !w-[255px] xl:!w-[343px] bg-[#e5dacf] rounded-[20px] xl:mr-5 overflow-hidden group"
                            onClick={() => handleItemClick(index)}
                            tabIndex={0}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    handleItemClick(index);
                                }
                            }}
                        >
                            <div className="c__favourites-item-image | w-full h-[180px] xl:h-[240px] u__img-contain">
                                {item.image && 
                                    <img src={item.image_url} alt={item.image_alt !== "" ? item.image_alt : `Image of ${item.name}`} className="c__igniteImage" />
                                }
                            </div>
                            <div className={`c__favourites-item-card | max-h-[55px] transition duration-300 ${
                                activeIndex === index ? 'translate-y-[-180px]' : ''
                            } xl:group-hover:translate-y-[-240px] xl:group-focus:translate-y-[-240px]`}>
                                <div className="c__favourites-item-card-inner | bg-black p-3  h-[235px] xl:h-[295px]">
                                    <h3 className="c__favourites-item-title | flex mb-6">
                                        <span className="flex-grow  text-white text-[16px] xl:text-[18px] pr-4 m:pr-0 font-bold font-mono capitalize leading-none">{item.name}</span>
                                        <img 
                                            src={plusIcon.src} 
                                            alt="Plus icon" 
                                            className={`flex-none transition duration-300 ${
                                                activeIndex === index ? 'rotate-45' : ''
                                            } xl:group-hover:rotate-45 xl:group-focus:rotate-45`}
                                        />
                                    </h3>
                                    <div className="c__favourites-item-tags | hidden gap-x-3 mb-3">
                                        {item.tags.filter(tag => tag.display_on_menu_items).map((tag, tagIndex) => (
                                            <span key={tagIndex} className="c__favourites-item-tag | inline-block w-[30px] h-[30px] grid text-center items-center text-white text-[15px] font-normal font-copy leading-loose bg-red rounded-full">
                                                {tag.name.charAt(0)}
                                            </span>
                                        ))}
                                    </div>
                                    <p className="c__favourites-item-description | text-white text-[17px] font-normal font-mono leading-snug tracking-wide">{item.description}</p>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
            </Swiper>
        </div>
    );
};

export default Favourites;